import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
import mutations from './mutations'
import state from './state'
import actions from './actions'

const store = new Vuex.Store({
    state,
    actions,
    mutations
})

export default store
